import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { UnitOfMeasureService } from "../../services/unit-of-measure/unit-of-measure.service";
import { GetStandardUoM, GetUoMConversions, GetUoMDependencies, GetUserDefaultUoM } from "./unit-of-measure.action";

/* istanbul ignore file */
export class UnitOfMeasureStateModel {
    userDefaultUoMSystemId: string;
    userDefaultUoMs: any[];
    userTimeZone: any;
    standardUomSystemId: string;
    standardUoMs: any[];
    uomConversions: any[];
    loadedUoMDependencies: boolean;
}

@State<UnitOfMeasureStateModel>({
    name:'unitOfMeasure',
    defaults: {
        userDefaultUoMSystemId:null,
        userDefaultUoMs: [],
        userTimeZone: null,
        standardUomSystemId: null,
        standardUoMs: [],
        uomConversions: [],
        loadedUoMDependencies: false
    }
})

@Injectable()
export class UnitOfMeasureState {
  constructor(
    private uomService : UnitOfMeasureService
  ) {}

    @Action(GetUserDefaultUoM)
    getUserDefaultUoM(ctx: StateContext<UnitOfMeasureStateModel>) {

    return this.uomService.getUserDefaultUoM()
    .pipe(
      tap(data => {
        if(!data.hasOwnProperty('message')) {
          ctx.patchState({
            userDefaultUoMSystemId: data.userDefaultSystemId,
            userDefaultUoMs: data.userDefaultUoMs,
            userTimeZone: data.userTimeZone
          })
        }
      }),
      catchError(() => {
        return of()
      }),
    )
  }

  @Action(GetStandardUoM)
  getStandardUoM(ctx: StateContext<UnitOfMeasureStateModel>) {
    
    return this.uomService.getStandardUoMSystem()
    .pipe(
      tap(data => {
        if(data) {
          ctx.patchState({
            standardUomSystemId: data.standardUnitSystemId,
            standardUoMs: data.standardUoMs
          })
        } 
      })
    )
  }

  @Action(GetUoMConversions)
  getUomConversions(ctx: StateContext<UnitOfMeasureStateModel>) {
    return this.uomService.getUoMConversions()
    .pipe(
      tap(data => {
        ctx.patchState({
          uomConversions: data
        })
      })
    )
  }

  @Action(GetUoMDependencies)
  getUoMDependencies(ctx: StateContext<UnitOfMeasureStateModel>) {
    return ctx.dispatch([new GetUoMConversions(), new GetStandardUoM(), new GetUserDefaultUoM()])
    .pipe(
      tap(() => {
        ctx.patchState({
          loadedUoMDependencies: true
        })
      })
    )
  }

}